import React from "react";
import clsx from "clsx";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Theme } from "@material-ui/core/styles";

import Breakpoints from "common/breakpoints";
import { EVetExamFields } from "../VetExamOverlay/options";
import FormSectionValidationResult from "../FormValidation/FormSectionValidationResult";
import { useVetExamContext } from "../VetExamOverlay/VetExamProvider/VetExamProvider";
import useStyles from "./styles";

interface IProps {
  children: React.ReactNode;
  title?: string;
  name?:
    | EVetExamFields.EXAM_JOGS
    | EVetExamFields.EXAM_DETAILS
    | EVetExamFields.RESULT;
  errorText?: string;
  actionsComponent?: React.ReactNode;
  isDarkBackground?: boolean;
  isRequired?: boolean;
  className?: string;
}

const FormBlock = (props: IProps) => {
  const {
    children,
    title = null,
    errorText,
    name,
    actionsComponent,
    isDarkBackground = false,
    isRequired = false,
    className
  } = props;

  const classes = useStyles();
  const { errors, shouldShowSectionValidationResult } = useVetExamContext();
  const matchesDownSX720 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SX_720)
  );

  const shouldShowValidationResult = [
    isRequired,
    shouldShowSectionValidationResult
  ].every(Boolean);
  const shouldShowMobileViewOfValidationResult = [
    shouldShowValidationResult,
    matchesDownSX720
  ].every(Boolean);

  return (
    <div
      className={clsx(className, classes.formBlock, {
        [classes.darkBackground]: isDarkBackground
      })}
    >
      {title && (
        <div>
          <div className={classes.formBlockHeader}>
            <span>{title}</span>
            {shouldShowValidationResult && (
              <FormSectionValidationResult
                className={classes.validationResultText}
                hasError={Boolean(errors[name])}
                errorText={errorText}
                withIcon={true}
              />
            )}
          </div>
          {shouldShowMobileViewOfValidationResult && (
            <FormSectionValidationResult
              hasError={Boolean(errors[name])}
              errorText={errorText}
            />
          )}
        </div>
      )}

      {children}

      {actionsComponent && (
        <div className={classes.formBlockFooter}>{actionsComponent}</div>
      )}
    </div>
  );
};

export default FormBlock;
